import BaseEntity from './base/BaseEntity.model';

export default class ComponentDesignConfig extends BaseEntity {
    public nombre!: string;
    public codigo!: string;
    public descripcion!: string;
    public configuration!: string;
    public attributes: ComponentDesignConfigAttribute[] = [];
}


export class ComponentDesignConfigAttribute extends BaseEntity {
    public componentDesignConfigId!: number; 
    public parentId!: number; 
    public guid!: string; //name
    public name!: string; //name
    public type!: string; //text, int, object
    public attributes: ComponentDesignConfigAttribute[] = []
}